<template>
  <div class="seleTest xi" id="app">
    <hd-com></hd-com>
    <div class="content-wrap">
      <div class="content">
        <div class="top-div flex-start">
          <div class="left-img"></div>
          <div class="top-title">{{ QuestionnaireResult.questionnaire.name }}</div>
        </div>
        <!-- 选择测试人 -->
        <div class="userTestRes-div flex-center">
          <div class="userTestRes-box flex-center-columns">
            <div class="content-center">
              <div class="flex-start" style="justify-content:space-between !important;"> 
                <div class="">
                  <div class="flex-start">
                    <div class="left-title"><img src="../../assets/img/result.png" mode="" style="width: 15px; height: 15px; margin-right: 12px" />本次自我健康管理测试分数:</div>
                      <div class="desc">
                        <span class=""> {{QuestionnaireResult.questionnaireDetermines[0].scores }} <span class="fen">分</span></span>
                      </div>
                  </div>
                  <span class="fenTime"> 测试时间： <span class="">{{QuestionnaireResult.time | timefilters }}</span></span>
                </div>
                <el-button type="primary" round @click="goAgain">重新测试</el-button>  
              </div>
            </div>
              <div class="" style="width:105%;margin-top: 35px;font-size: 20px;">
                  <div class="" style="border-bottom: 1px dashed #999999;padding-bottom: 30px;">
                    <div class="" style="font-size: 24px;font-weight: bold;">
                      测试回顾
                    </div>
                    <div class="" style="margin-top: 15px;font-size: 18px;">
                      做对<span style="color: #00B29D;padding: 0 5px;">{{queTrueNum.length}}</span>题,做错<span style="color: #D21B1B;padding: 0 5px;">{{queFalseNum.length}}</span>题,巩固一下知识点吧
                    </div>
                  </div>
                  <div class="" v-for="(item,index) in resultScoreList1" :key="index" style="margin-bottom: 40px;margin-top: 29px;">
                    <div>
                      <div >
                        {{index + 1 + "."}}{{item.questionContent.text}}
                      </div>
                      <div class="" style="display: flex;align-items: center;justify-content: space-between;">
                        <div class="">
                          <div style="display: flex;align-items: center;margin-top: 21px;">
                            <div class="lineDetail">
                              
                            </div>
                            <div class=""  v-if="item.questionType == 'Judge'">
                              你的答案：{{ item.myQueTrue}}
                            </div>
                            <div class="" v-else>
                              你的答案：{{item.questionCategory == '总分' ? '(' + item.queTrue +')' :  '(' + item.questionCategory.toUpperCase() +')' }} {{item.myQueTrue}}
                            </div>
                            
                          </div>
                          <div style="display: flex;align-items: center; color: #00B29D;margin-top: 20px;  font-size: 22px;">
                            <div class="lineDetail">
                              
                            </div>
                            <div class="" v-if="item.questionType == 'Judge'">
                              正确答案：{{item.queTrue}} 
                            </div>
                            <div class="" v-else>
                              <!-- 正确答案：{{item.queTrue}} {{'('+ item.queTrueDes +')'}}  -->
                               正确答案： {{'('+ item.queTrue +')'}} {{item.queTrueDes}}
                            </div>
                            
                          </div>
                        </div>
                        <img v-if="item.questionCategory == '总分'" src="../../assets/img/right.png" mode="" style="width: 40px;height: 40px;" />
                        <img v-else src="../../assets/img/wrong.png" mode="" style="width: 40px;height: 40px;" />
                      </div>
                  
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
    <rt-bar></rt-bar>
  </div>
</template>

<script>
import hdCom from "../../components/header";
import ftCom from "../../components/footer";
// import rtBar from "../../components/right";
import { Test } from "../../components/company/test";
export default {
  name: "selfTest",
  components: {
    hdCom,
    ftCom,
    // rtBar,
  },
  data() {
    var test = new Test(this.TokenClient, this.Services.Statics);
    return {
      testDomain: test,
      userInfo: this.$store.state.localData.userInfo,
      resId: this.$route.query.resId,
      answerUserId: this.$route.query.answerUserId,
      QuestionnaireResult: {
        questionnaire: {
          name: "",
        },
        questionnaireDetermines: [
          {
            scores: 0,
          },
        ],
      },
      qingXiang: [],
      tiZhi: [
        {
          name: "",
        },
      ],
      result: "",
      resultList: [],
      categories: [],
      series: [],
      InfoSummarize: "",
      adviseInfo: {
        name: "",
        infos: [
          {
            info: "",
          },
        ],
      },
      indicator: [],
      resultScoreList: [],
      resultScoreList1: [],
      resultScoreList2: [],
      pdfUrl: "",
      QRCodeUrlPDF: "",
      queTrueNum:[],
      queFalseNum:[]
    };
  },
  mounted() {
    this.$bus.$emit("isShowChangeSize");
    this.$nextTick(() => {
      this.getResult();
    });
  },
  methods: {
    goAgain(){
        this.$router.push({
          path: "/company/startTestTotal",
        });
    },
    getResult() {
      var _this = this;
      this.testDomain.getUserResultById(
        this.resId,
        res => {
          this.QuestionnaireResult = res.data;
          	for (let i=0; i< res.data.userOptions.length; i++) {
							if (res.data.userOptions[i].questionCategory == '总分') {
								_this.queTrueNum.push(res.data.userOptions[i])
							} else {
								_this.queFalseNum.push(res.data.userOptions[i])
							}
							res.data.userOptions[i].questionContent = JSON.parse(res.data.userOptions[i].questionContent)
							res.data.userOptions[i].questionContent.imgPath = JSON.parse(res.data.userOptions[i].questionContent.imgPath)
							for (let j=0; j<res.data.userOptions[i].optionScores.length; j++) {
								if (res.data.userOptions[i].optionScores[j].category == '总分' && res.data.userOptions[i].questionType == 'Radio') {
									if (j== 0) {
										res.data.userOptions[i].queTrue = 'A'
                    res.data.userOptions[i].queTrueDes = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
									}
									if (j== 1) {
										res.data.userOptions[i].queTrue = 'B'
                    res.data.userOptions[i].queTrueDes = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
									}
									if (j== 2) {
										res.data.userOptions[i].queTrue = 'C'
                    res.data.userOptions[i].queTrueDes = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
									}
									if (j== 3) {
										res.data.userOptions[i].queTrue = 'D'
                    res.data.userOptions[i].queTrueDes = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
									}
								}
								if (res.data.userOptions[i].optionScores[j].category == '总分' && res.data.userOptions[i].questionType == 'Judge') {
										res.data.userOptions[i].queTrue = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
								}
								if (res.data.userOptions[i].optionScores[j].category == res.data.userOptions[i].questionCategory) {
										res.data.userOptions[i].myQueTrue = JSON.parse(res.data.userOptions[i].optionScores[j].optionContent).text
								} 
							}
						}
						_this.resultScoreList1 = res.data.userOptions
        },
        error => {
          console.log("请求失败!请刷新重试:", error);
        }
      );
    },
  },
};
</script>

<style scoped>

.content-wrap {
  background: #fff;
}

.content {
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 295px - 140px);
  padding: 30px 20px;
  background: url("../../assets/img/bg001.png") top;
  background-size: 100% 1050px;
}

.top-div {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 30px;
}

.top-div .left-img {
  width: 24px;
  height: 24px;
  border: 5px solid #ebeefd;
  background: linear-gradient(90deg, #4db992, #81dfa7);
  box-shadow: 0px 3px 6px 0px rgba(18, 184, 149, 0.3);
  border-radius: 50%;
  margin-right: 10px;
}

.top-div .top-title {
  width: auto;
  height: 29px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}

.addUser-div .w-18 {
  width: 80%;
}

.userTestRes-div {
  background: #fff;
  width: 80%;
  margin: 0 auto;
  height: auto;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 40px;
  padding: 40px;
}

.userTestRes-div .userTestRes-box {
  width: 90%;
}

.top-img {
  width: 100%;
  /* margin-bottom: 40px; */
}

.top-img div.title {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #019582;
  margin-left: 10px;
}


.mark {
  cursor: pointer;
}

.top-1 .top-title1 .tip {
  font-size: 18px;
}

.top-1 .left-tongJi {
  width: 30%;
  margin-right: 5%;
}
.desc {
  font-weight: bold;
  font-size: 32px;
  color: #333333;
  margin-left: 12px;
}

.userTestRes-div .userInfo {
  color: #999999;
}

.content-center {
  border-radius: 16px;
  border: 1px solid #01C1AA;
  padding: 33px 30px;
  width: 100%;
}
.fenTime {
  font-size: 20px;
  color: #999999;
  margin-left: 27px;
}

.share-box {
  font-size: 15px;
}

.share-box .img-icon {
  width: 16px;
  height: 16px;
  margin-right: 2px;
  margin-bottom: -2px;
}

.share-box .left {
  margin-right: 10px;
}

.content-center .res-box {
  width: 100%;
  border: 1px solid #01c1aa;
  border-radius: 15px;
  padding: 10px 5px 5px;
  margin: 10px 0;
}
.flexlr {
  display: flex;
  justify-content: space-between;
}

.left-title {
  font-size: 24px;
  color: #333333;
  font-weight: bold;
}

.fen {
  font-size: 20px;
  font-weight: 400;
}

.color1 {
  color: #019582;
}

.bg1 {
  background: #d0f5f1;
}

.color2 {
  color: #1a74e9;
}
	.lineDetail {
		width: 4px;
		height: 20px;
		background: #00C2BF;
		margin-right: 10px;
	}
</style>
